import { render, staticRenderFns } from "./Orden.vue?vue&type=template&id=0f7b4199&scoped=true&"
import script from "./Orden.vue?vue&type=script&lang=js&"
export * from "./Orden.vue?vue&type=script&lang=js&"
import style0 from "./Orden.vue?vue&type=style&index=0&id=0f7b4199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b4199",
  null
  
)

export default component.exports